<template>
  <div class = "fixed-content">



      <md-dialog :md-active.sync="isPictureModalShowing">
      <md-dialog-content>
        <h3>STAGE Pictures</h3>
        <calling-api path="/api/w/ccic/photo/get">
          <view-image :key="p.photoUrl" :src="p.photoUrl" v-for="p in photos">
            <p>Photo Type: {{getPhotoName(p)}}</p>
          </view-image>
        </calling-api>
      </md-dialog-content>

      
      <md-dialog-actions>
        <!-- <download-pictures-button :zip-file-name="photoZipFileName"
                                  :file-prefix-for-each-file="filePrefixForEachFile"
                                  :pics="photos.map(it=>it.photoUrl)"/> -->
        <md-button class="md-primary" @click="isPictureModalShowing = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>



    <div >
      <callingApiCenter :paths="['/api/w/gst/WebSearchCockpit' ,'/api/w/gst/updateyardstage','/api/w/gstConfirm/WebUpdateConfirmLoads']">
      <md-button class="md-raised custButton "  @click="doAction" ><span class="icons-center material-icons">create</span>BACK</md-button>
      <md-button class="md-raised custButton "  :disabled="!canChange" @click="doEdit" ><span class="icons-center material-icons">create</span>Edit</md-button>
      <md-button class="md-raised custButton "  :disabled="!canSave" @click="doSave" ><span class="icons-center material-icons">create</span>Save</md-button>
      <md-button class="md-raised custButton " :disabled="!canUnderCheck" @click="doUC"><span class="icons-center material-icons">create</span> Under Check</md-button>
      <md-button class="md-raised custButton "  :disabled="!canUnUnderCheck" @click="doCF"><span class="icons-center material-icons">create</span> Check finish</md-button>
      <md-button class="md-raised custButton "  :disabled="!canConfirm" @click="doLC"><span class="icons-center material-icons">create</span> Confirm</md-button>
      <md-button class="md-raised custButton " :disabled="!canUnConfirm" @click="doLU" ><span class="icons-center material-icons">create</span> Unconfirm</md-button>
      <md-button class="md-raised custButton "  :disabled="canLast" @click="doBack" ><span class="icons-center material-icons">create</span>LAST</md-button>
      <md-button class="md-raised custButton "  :disabled="canNext" @click="doNext" ><span class="icons-center material-icons">create</span>NEXT</md-button>


    </callingApiCenter>
    </div>
    
    <div class=" md-layout md-gutter md-alignment-center ">
    <md-toolbar>
      <h3 class="md-title">Load Information</h3>
    </md-toolbar>
    </div>
    <div class="md-layout md-gutter md-alignment-center ">
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field>
            <label>Load Key</label>
            <md-input v-model="params.loadKey" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Load Status</label>
            <md-input v-model="params.loadStatus" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Reference #</label>
            <md-input v-model="params.referenceNo" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field>
            <label>Customer Order</label>
            <md-input v-model="params.customerPO" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Container Size</label>
            <md-input v-model="params.ctnrType" disabled></md-input>
        </md-field>
    </div>
    </div>
    <div class="md-layout md-gutter md-alignment-center ">
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Booking</label>
            <md-input v-model="params.bookObl" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>GST DO</label>
            <md-input v-model="params.deliveryOrder" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field>
            <label>GST DO ITEM</label>
            <md-input v-model="params.gstIBS" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Change Date</label>
            <md-input v-model="params.changeDate" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Confirm Date</label>
            <md-input v-model="params.confirmDate" disabled></md-input>
        </md-field>
    </div>
    </div>


    <div class="md-layout md-gutter md-alignment-center ">
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field>
            <label>Route</label>
            <md-input v-model="params.route" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <label>Pick up Location</label>
       <md-field>
            <!-- <label>Pick up Location</label>
            <md-input v-model="params.pickUpLocationName" disabled></md-input> -->
             <master-data-display group="GST_LOCATION" :tag-id="params.pickupLocationCode"/>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
      <label>Delivery Location</label>
       <md-field>
            <!-- <label>Delivery Location</label>
            <md-input v-model="params.deliverLocationName" disabled></md-input> -->
             <master-data-display group="GST_LOCATION" :tag-id="params.deliverLocationCode"/>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field>
            <label>Change By</label>
            <md-input v-model="params.changeBy" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Confirm By</label>
            <md-input v-model="params.confirmBy" disabled></md-input>
        </md-field>
    </div>
    </div>


    <div class=" md-layout md-gutter md-alignment-center ">
    <md-toolbar>
      <h3 class="md-title">Delivery Related</h3>
    </md-toolbar>
    </div>
    <div class="md-layout md-gutter md-alignment-center ">
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field >
            <label>Prepull</label>
            <md-input v-model="params.prepull" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Drop Off</label>
            <md-input v-model="params.dropoff" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Pier Pass</label>
            <md-input  v-model="params.pierpass" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field>
            <label>Dry Run</label>
            <md-input v-model="params.dryrun" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Bobtail</label>
            <md-input v-model="params.bobtail" disabled></md-input>
        </md-field>
    </div>
    </div>
    <div class="md-layout md-gutter md-alignment-center ">
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Additional Cost to Driver</label>
            <md-input v-model="params.addCostForDriver" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field>
            <label>Add Cost to Customer</label>
            <md-input v-model="params.additionalCostToCustomer" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Total Hours</label>
            <md-input v-model="params.totalHours" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Driver waiting paid out</label>
            <md-input v-model="params.waitingTimePaidOut" disabled></md-input>
        </md-field>
    </div>
     <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Driver waiting charge back</label>
            <md-input v-model="params.waitingTimeChargeBack" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>
    </div>


    <div class=" md-layout md-gutter md-alignment-center ">
    <md-toolbar>
      <h3 class="md-title">Chassis Fee Related</h3>
    </md-toolbar>
    </div>
    <div class="md-layout md-gutter md-alignment-center ">
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field>
            <label>Street Turn</label>
            <md-input v-model="params.source" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Carrier</label>
            <md-input v-model="params.carrier" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>CHZ Start Date</label>
            <md-input  v-model="params.chassisStartLocal" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       
        <div>In Gate Photo</div>
        
        <div class = "middlebox">{{params.inGatePhoto == null ? '' : '&#x2713;'}}</div>
       
        
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <!-- <md-field>
            <label>Load Pictures</label>
            <md-input v-model="params.pictures" disabled></md-input>
        </md-field> -->

         <div class = "photoFont">Pictures: </div>
        <a href="" @click.prevent="toggleItemPhoto(params.pictureList)">{{params.pictures}} photos</a>



    </div>
    </div>

    <div class="md-layout md-gutter md-alignment-center ">
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field>
            <label>Own Chassis</label>
            <md-input v-model="params.ownChassis" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Chassis Vendor</label>
            <md-input v-model="params.chassisVendor" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>CHZ End Date</label>
            <md-input  v-model="params.chassisEndLocal" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            
                <div>In Gate Photo </div>
                <div class = "middlebox">{{params.outGatePhotos == null ? '' : '&#x2713;'}}</div>
    </div>

    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
    </div>
    </div>
    

    <div class="md-layout md-gutter md-alignment-center ">
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field>
            <label>Container</label>
            <md-input v-model="params.containerNo" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Chassis</label>
            <md-input v-model="params.chassisNo" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>Chassis Days</label>
            <md-input  v-model="params.chassisDays" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
        <md-field>
            <label>CHZ days paid out</label>
            <md-input v-model="params.chzDaysPaidOut" disabled></md-input>
        </md-field>
    </div>
    <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
       <md-field>
            <label>CHZ days charge back</label>
            <md-input v-model="params.chzDaysChargeBack" :disabled ="!getEditMode"></md-input>
        </md-field>
    </div>
    </div>

    <md-toolbar>
        <h3 class="md-title">Stage Summary</h3>
    </md-toolbar>
    <div v-for="item in stageList" :key="item.loadKeyWithStageNo">
        <md-toolbar>
            <h5 class="md-title">Stage # {{item.stage}}</h5>
        </md-toolbar>   

        <div class="md-layout md-gutter md-alignment-center ">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                    <label>IN/OUT</label>
                    <md-input v-model="item.stageType" disabled></md-input>
                </md-field>
            </div>
        

        
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                    <label>Cost Relevant</label>
                    <md-input v-model="item.costRelevant" disabled></md-input>
                </md-field>
            </div>
        

      
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                    <label>Freight Type</label>
                    <md-input v-model="item.freightType" disabled></md-input>
                </md-field>
            </div>
        

        
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                    <label>Driver</label>
                    <md-input v-model="item.driverId" disabled></md-input>
                </md-field>
            </div>
       
        
       
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                    <label>Delivery End Date</label>
                    <md-input v-model="item.taskEndLocal" disabled></md-input>
                </md-field>
            </div>
       

       




       
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                    <label>Total Hours</label>
                    <md-input v-model="item.totalHours" disabled></md-input>
                </md-field>
            </div>
       


       
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                    <label>Driver waiting payout</label>
                    <md-input v-model="item.waitingTimePaidOut" disabled></md-input>
                </md-field>
            </div>
       

       
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                    <label>Additional Cost to Driver</label>
                    <md-input v-model="item.addCostForDriver" disabled></md-input>
                </md-field>
            </div>
       

        
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                    <label>Stage Confirm Date</label>
                    <md-input v-model="item.confirmDateLocal" disabled></md-input>
                </md-field>
            </div>
        


      
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                    <label>Stage Confirm By</label>
                    <md-input v-model="item.confirmBy" disabled></md-input>
                </md-field>
            </div>

                <div class="md-layout md-gutter md-alignment-center ">
            <div class="holderFull md-layout-item md-medium-size-100 md-small-size-50 md-xsmall-size-100">
                <md-field>
                    <label>Dispatch Instruction</label>
                    <md-input v-model="item.dispatcherInstruction" disabled></md-input>
                </md-field>
                </div>
            </div>

        <div class="md-layout md-gutter md-alignment-center ">
            <div class="holderFull md-layout-item md-medium-size-100 md-small-size-50 md-xsmall-size-100">
                <md-field>
                    <label>Driver Remark</label>
                    <md-input v-model="item.comment" disabled></md-input>
                </md-field>
            </div>
        </div>

        <div class="md-layout md-gutter md-alignment-center ">
            <div class="holderFull md-layout-item md-medium-size-100 md-small-size-50 md-xsmall-size-100">
                <md-field>
                    <label>Confirm Remark</label>
                    <md-input v-model="item.stageConfirmComment" :disabled ="!getEditMode"></md-input>
                </md-field>
            </div>
        </div>


        </div>  


     </div>










    








    






   </div>

  
   

</template>

<script>

/* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  //import api from "../api";
  import { newAPIPost } from '../api';
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";





export default {

    data: () => ({
     loadList: [],
     params: [],
     pointer: null,
     indicator: false,
     drivers: null,
     edit:false,
     stageList: [],
     photos: [],
     testphotos: [],
     photoZipFileName: '',
     filePrefixForEachFile: '',
     isPictureModalShowing: false,

    }),


    components: {
      callingApiCenter,
      AutocompleteCcicLocationSelect,
  
    },


    computed: {
        ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
      ]),

      canLast(){
        return this.pointer == 0;
      },


      canNext(){
        return this.pointer == this.loadList.length - 1;
      },


      getEditMode()
        {
            return this.edit;
        },

    canChange() {
        if (this.params.loadStatus != 'LDC' )
          {
              return true
          }
      },

      canSave() {
        if (this.edit == true )
          {
              return true
          }
      },


    canUnderCheck() {
        if (this.params.loadStatus != 'LDC' 
          && this.params.loadStatus != 'LUC' )
          {
              return true
          }
          
          
      },

      canUnUnderCheck() {

        if (this.params.loadStatus == 'LUC' )
          {
              return true
          }

      },

      canConfirm() {
        if (this.params.loadStatus != 'LDC' 
          && this.params.loadStatus != 'LUC' )
          {
              return true
          }
      },


      canUnConfirm() {
        if (this.params.loadStatus == 'LDC' )
          {
              return true
          }
      },


    

      


    },

    


    async mounted() {

        console.log('test');

        if (Array.isArray(this.$route.params))
        {
             this.loadList = this.$route.params
        }
        else
        {
            this.loadList = [this.$route.params]
           
        }

        

       // this.loadList = this.$route.params;

       

        
        
        this.params = this.loadList[0];
        if (this.params.chassisDays == null)
        {
             this.params.chassisDays = this.getDifferentDate(this.params.chzEndDate, this.params.chzStartDate)
        }
       
        console.log(this.params);
        this.pointer = 0;
          this.drivers = null;
      this.$store.dispatch('getUsersByCategory', { category: 'L' })
        .then((res) => {
          this.drivers = res;
        });
        this.doSearch();
    },
    methods: {



        async toggleItemPhoto(item) {
        this.isPictureModalShowing = true;
        this.photos = item;
        
        // this.photoZipFileName = `${item.application.bookingNo}_${item.application.poNo}_${item.containerNo}.zip`;
        // this.filePrefixForEachFile = `${item.containerNo}-`;

      },


      getPhotoName(photo) {
        const photoName = decodeURI(photo.photoUrl.replace(/.*\//g, ""));
        return `${this.filePrefixForEachFile || ''}${photoName}`;
      },



        getDifferentDate(date1, date2){

            if (date1 == null) return null
            if (date2 == null) return null
            return moment(date1).diff(moment(date2), 'days')
 
        },

        doAction(){

            this.$router.go(-1);
        },

        doBack(){
          
          this.pointer = this.pointer - 1;
          this.params = this.loadList[this.pointer];
          if (this.params.chassisDays == null)
        {
             this.params.chassisDays = this.getDifferentDate(this.params.chzEndDate, this.params.chzStartDate)
        }
       
          this.doSearch();

        },

        doNext(){

          this.pointer = this.pointer + 1;
          this.params = this.loadList[this.pointer];
          if (this.params.chassisDays == null)
        {
             this.params.chassisDays = this.getDifferentDate(this.params.chzEndDate, this.params.chzStartDate)
        }
       
          this.doSearch();

        },


        doNew(){

            this.items.push({
            salesOffice: this.params.salesOffice,
            loadKeyWithStageNo: null,
            stageStatus: null,
            appointment: null,
            apptDate: null,
            driverId: null,
            truckId: null,
            costRelevant: null,
            freightType: null,
            dispatcherInstruction: null,
            containerPickupLocation: null,
            containerDropOffLocation: null,
            offsiteScale: null,
            ccicDropOffLocationCode: null,
            pickupDate: null,
            // seqNo: it.loadKey,
            pickupLocationCode: null,
            pickUpLocationName: null,
            deliverLocationCode: null,
            deliverLocationName: null,
            deliveryOrder: this.params.deliveryOrder,
            editing : true,
            });
        },


        doEdit(){
            
            this.params.change = true;
            this.edit = true
            console.log(this.params.change);
            console.log(this.getEditMode);
             console.log(this.params);
        },


        doSave(item)
        {
            const request = this.params
            request.action = 'CHANGE';
            console.log(request);
            //api.post("/api/w/gstConfirm/WebUpdateConfirmLoads", request)
            newAPIPost("/api/w/gstConfirm/WebUpdateConfirmLoads", request)
          .then(() => {
            this.$store.commit('clearApiError');
            //this.doSearch();
            this.edit = false;
          });
        },


        async doUC() {
          
            const requests = 
            [{
                salesOffice: this.params.salesOffice,
                loadKey: this.params.loadKey,
                status: this.params.loadStatus,
            }]
            //api.post("/api/w/gstConfirm/WebUpdateConfirmLoads", {
            newAPIPost("/api/w/gstConfirm/WebUpdateConfirmLoads", {
            action:"UC",
            status:requests,
            })
            .then(() => {
                this.$store.commit('clearApiError');
               // this.doSearch();
            });
         
      },

      

      async doCF() {
       const requests = 
            [{
                salesOffice: this.params.salesOffice,
                loadKey: this.params.loadKey,
                status: this.params.loadStatus,
            }]
         //api.post("/api/w/gstConfirm/WebUpdateConfirmLoads", {
         newAPIPost("/api/w/gstConfirm/WebUpdateConfirmLoads", {
           action:"CF",
           status:requests,
         })
          .then(() => {
            this.$store.commit('clearApiError');
           // this.doSearch();
          });
         
      },

      

       async doLC() {
        const requests = 
            [{
                salesOffice: this.params.salesOffice,
                loadKey: this.params.loadKey,
                status: this.params.loadStatus,
            }]
         //api.post("/api/w/gstConfirm/WebUpdateConfirmLoads", {
         newAPIPost("/api/w/gstConfirm/WebUpdateConfirmLoads", {
           action:"LC",
           status:requests,
         })
          .then(() => {
            this.$store.commit('clearApiError');
            //this.doSearch();
          });
         
      },


      async doLU() {
       const requests = 
            [{
                salesOffice: this.params.salesOffice,
                loadKey: this.params.loadKey,
                status: this.params.loadStatus,
            }]
         //api.post("/api/w/gstConfirm/WebUpdateConfirmLoads", {
         newAPIPost("/api/w/gstConfirm/WebUpdateConfirmLoads", {
           action:"LU",
           status:requests,
         })
          .then(() => {
            this.$store.commit('clearApiError');
           // this.doSearch();
          });
         
      },



    
      

      








        doCancel(item){
            item.editing = false;
        },

        canEdit(item){
          return item.editing != null
      },

        doSearch()
    {
        if (this.params != null)
        {
            const data = {
            loadKey: this.params.loadKey || this.params.seqNo,
            companyOffice: 'GST_' + this.params.salesOffice
                }
            //api.post("/api/w/gst/WebSearchCockpit", data)
            newAPIPost("/api/w/gst/WebSearchCockpit", data)
          .then((item) => {
            this.$store.commit('clearApiError');


            item.forEach((it) => {
          it.taskEndLocal = dateFormat.gstDateFormat(it.taskEnd);
          it.confirmDateLocal = dateFormat.gstDateFormat(it.confirmDate);

        });
            this.stageList = item;
            console.log(this.stageList);
          });

        }
    },
    }

}
</script>

<style scoped>

.custButton {
     margin: 10px;
    width: 120px;
    height: 40px;
    line-height:40px;
    font-size: 0.75rem;
   
}


.holder {
    /* background: blue; */
    margin: 20px;
    width: 800px;
    height: 200px;
}


.holderFull {
    /* background: blue; */
    margin: 20px;
    margin-left: 35px;
    width: 800px;
    height: 200px;
}

.header{
    text-align: left;
}

.fixed-content {
    padding-left: 10%;
    padding-right: 10%;
    position:fixed;
    overflow-y:auto;
    overflow-x:hidden;
}

.md-layout-item {
  height: 50px;
  margin-top: 8px;
  margin-bottom: 8px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  /* border:1px solid #000; */
  /* background: #ce93d8; */
}


.middlebox{
    padding-top: 20px;
    padding-bottom: 8px;

}

.md-title {
    margin-left: 20px;
}

.photoFont {
    font-size: 1rem;
    color: gray;
    padding-bottom: 10px;
    
}



</style>